import { isWorkday } from './morning';

/**
 * Termenul de livrare în zile lucrătoare (Ticket 08, P13): „5 zile lucrătoare” dintr-o ofertă rămân
 * 5 zile lucrătoare, nu 5 sau 7 zile calendaristice. Zilele libere sunt cele din `morning.ts`:
 * weekendul și sărbătorile legale ale țării firmei (în România, cu Paștele și Rusaliile ortodoxe).
 * Datele sunt 'AAAA-LL-ZZ', ziua din calendar, fără ore și fusuri.
 */

const DAY = 86_400_000;
const plus = (day: string, n: number): string =>
  new Date(Date.parse(`${day}T00:00:00Z`) + n * DAY).toISOString().slice(0, 10);

/** Ziua în care se împlinesc `n` zile lucrătoare de la `from` (ziua de pornire nu se numără). */
export function addWorkingDays(from: string, n: number, country = 'RO'): string {
  let day = from;
  for (let left = n; left > 0; ) {
    day = plus(day, 1);
    if (isWorkday(day, country)) left--;
  }
  return day;
}

/** Când ajunge marfa, pornind de la `from`: zile lucrătoare sau calendaristice, după ofertă. */
export function deliveryDate(from: string, days: number, working: boolean, country = 'RO'): string {
  return working ? addWorkingDays(from, days, country) : plus(from, days);
}
